import React, { useState } from "react";
import Logo from "./logo";
import iconOpen from "../../assets/images/Icons/menuOpen.svg";
import iconClose from "../../assets/images/Icons/menuClose.svg";
import "../../styles/screens/homeSection.scss";
import { Link } from "react-router-dom";
import de from "../../assets/texts/de.json";
import sr from "../../assets/texts/sr.json";
import { useLanguage } from "../../i18n/LanguageContext";

const MobileNav = () => {
  const [open, setOpen] = useState(false);
  const { language, setLanguage } = useLanguage();
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const toggleMenu = () => setOpen(!open);
  const closeMobileMenu = () => setOpen(false);

  const toggleDropdown = (event) => {
    event.stopPropagation();
    setDropdownOpen(!dropdownOpen);
  };

  const t = language === "sr" ? sr : de;

  const menuItems = [
    { id: "home", label: t.nav.home, path: "/" },
    {
      id: "services",
      label: t.nav.services,
      path: "",
      subItems: [
        {
          id: "serviceFirst",
          label: `   ${t.services.service[0].name}`,
          path: "/serviceFirst",
        },
        {
          id: "serviceSecond",
          label: t.services.service[1].name,
          path: "/serviceSecond",
        },
        { id: "serviceThird", label: t.services.service[2].name, path: "/serviceThird" },
        {
          id: "serviceFourth",
          label: t.services.service[3].name,
          path: "/serviceFourth",
        },
      ],
    },
    { id: "about", label: t.nav.about, path: "/#about" },
    { id: "contact", label: t.nav.contact, path: "/#contact" },
  ];

  return (
    <div className="mobile-nav">
      <div className="mobile-left">
        <button className="lang-btn-mobile" title={language === 'sr' ? 'Deutsch' : 'Srpski'} onClick={() => setLanguage(language === 'sr' ? 'de' : 'sr')}>
          {language === 'sr' ? 'DE' : 'SR'}
        </button>
        <nav role="navigation">
          <div id="menuToggle" onClick={toggleMenu}>
            <img
              src={open ? iconClose : iconOpen}
              alt={open ? "Close" : "Open"}
              className={open ? "burger__closed" : "burger__menu"}
            />
            <ul id="menu" className={open ? "open" : ""}>
            {menuItems.map((item) => (
              <li key={item.id}>
                {item.subItems ? (
                  <div className="service-item" onClick={toggleDropdown}>
                    {item.label}
                    {dropdownOpen && (
                      <ul>
                        {item.subItems.map((subItem) => (
                          <li key={subItem.id}>
                            <Link to={subItem.path} onClick={closeMobileMenu}>
                              {subItem.label}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                ) : (
                  <a href={item.path} onClick={closeMobileMenu}>
                    {item.label}
                  </a>
                )}
              </li>
            ))}
            </ul>
          </div>
        </nav>
      </div>
      <Logo />
    </div>
  );
};

export default MobileNav;
